import React from "react";
import CodeHideAboutLogo from "../../../assets/codehidelogo.png";
import "./CodeHideAbout.css";

const CodeHideAbout = () => {
  return (
    <div className="code-hide-About-container">

      <div className="code-hide-About-content">
        <h1 className="code-hide-About-title">CodeHide.com</h1>
        <p className="code-hide-About-text">
        Embark on a journey into the digital realm of CodeHide.com, where
          innovation transcends choice to become a resounding imperative.
          <br></br>
          <br></br>
          Our sanctuary beckons industries, governments, and academia to
          converge, birthing tangible form from abstract aspirations. Witness
          algorithms composing intricate symphonies, applications crafting
          digital masterpieces, and data unveiling profound insights.
          <br></br>
          <br></br>
          Comprising brilliant minds, our team engineers solutions that embody
          the very core of excellence. From the arcane realm of software sorcery
          to the meticulous architecture of databases, each facet is a testament
          to the virtuosity that resides within CodeHide.com.
          <br></br>
          <br></br> 
          Trust here is not an abstract notion; it is the bedrock upon which we
          chisel destinies in the digital landscape.
        </p>
      </div>
      <a href="https://codehide.com" target="_blank" rel="noopener noreferrer">
        <div className="code-hide-About-logo">
          <img src={CodeHideAboutLogo} alt="BidTypeAbout Logo" />
        </div>
      </a>
    </div>
   
   );
};

export default CodeHideAbout;